import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito equipo de gimnasio?',
    a: 'No, todo se hace con hábitos en casa.'
  }, {
    q: '¿Es una dieta Keto?',
    a: 'No, usamos carbohidratos estratégicos para proteger tu tiroides.'
  }, {
    q: '¿Tengo que pasar hambre?',
    a: 'Al contrario, aprenderás a comer más para quemar más.'
  }, {
    q: '¿Funciona si tengo hipotiroidismo?',
    a: 'Sí, el protocolo ayuda a optimizar la conversión hormonal natural.'
  }, {
    q: '¿Cuánto tiempo toma ver resultados?',
    a: 'Los cambios en energía son inmediatos; los cambios físicos ocurren a partir de los 14-21 días.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-gray-50" data-id="element-30">
      <div className="container px-4 mx-auto max-w-3xl" data-id="element-31">
        <FadeIn data-id="element-32">
          <h2 className="mb-12 text-3xl font-bold text-center text-gray-900 md:text-4xl" data-id="element-33">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-34">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-35">
              <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden" data-id="element-36">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="flex items-center justify-between w-full p-6 text-left focus:outline-none" data-id="element-37">
                  <span className="text-lg font-bold text-gray-900" data-id="element-38">
                    {faq.q}
                  </span>
                  <span className={`ml-4 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-39">
                    <svg className="w-6 h-6 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-40">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" data-id="element-41" />
                    </svg>
                  </span>
                </button>
                <AnimatePresence data-id="element-42">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-43">
                      <div className="px-6 pb-6 text-lg text-gray-700" data-id="element-44">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}